import { Card, Typography } from '@mui/material'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import AssetPreviewDisplay from '../assetpreviewdisplay/AssetPreviewDisplay'
import { CollectionTypography } from '../collectiontypography/CollectionTypography'
import Link from '../common/util/input/Link'
import { renderProgressBar } from '../drops/DropProgressBar'

export const TeaserCard = ({
    image,
    video,
    thumbnail,
    author,
    name,
    collectionImage,
    collectionThumbnail,
    verified,
    link,
    index,
    price,
    soldOut,
    numClaimed,
    maxClaimable,
    isPfp,
}) => {
    const { t } = useTranslation('common')
    return (
        <Card
            className={cn(
                'group relative w-full h-auto rounded-lg shadow bg-zinc-300 dark:!bg-paper hover:bg-zinc-200',
                'dark:!bg-paper hover:dark:!bg-paperl',
                'transition color duration-500',
            )}
            tabIndex={index}
        >
            {renderProgressBar(numClaimed, maxClaimable)}
            {isPfp ? (
                <div
                    className={cn(
                        'text-primary text-3xl sm:text-sm lg:text-2xl font-extrabold',
                        'absolute top-4 left-2 -rotate-9',
                        'border-primary p-1 rounded-md border-4 bg-slate-900/40 z-50 text-center whitespace-nowrap',
                    )}
                >
                    {t('drops.generative_drop')}
                </div>
            ) : null}
            {soldOut && (
                <div
                    className={cn(
                        'text-red-600 text-3xl sm:text-sm lg:text-2xl font-extrabold uppercase',
                        'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rotate-12',
                        'border-red-600 p-2 rounded-md border-4 bg-red-100/90 z-50 text-center whitespace-nowrap',
                    )}
                >
                    {t('drops.sold_out')}
                </div>
            )}
            <Link href={link} className={'h-auto w-full overflow-hidden'}>
                <AssetPreviewDisplay
                    className="h-auto p-1/2 aspect-1/1"
                    asset={{
                        image: thumbnail ? thumbnail : image,
                        video: thumbnail ? null : video,
                    }}
                    previewDuration={0}
                    grayScale={soldOut}
                    fetchPriority={'high'}
                    imgClassName={
                        ' transition transform duration-500 hover:scale-105 cursor-pointer'
                    }
                />
            </Link>
            <Link
                href={link}
                className={cn(
                    'transition transform duration-500 translate-y-0 group-hover:-translate-y-[99%] w-full',
                    'absolute bg-zinc-200 dark:!bg-paper group-focus:-translate-y-[99%] text-center z-100',
                    { 'h-1/2': price || maxClaimable },
                    { 'h-1/3': !(price || maxClaimable) },
                )}
            >
                <CollectionTypography
                    author={author}
                    collectionImage={collectionImage}
                    collectionThumbnail={collectionThumbnail}
                    verified={verified}
                />
                <div>
                    <Typography
                        variant="body1"
                        fontWeight="bold"
                        color="text-white dark:!text-black"
                    >
                        {name.length > 20
                            ? name.substring(0, 20) + '...'
                            : name}
                    </Typography>
                    {isPfp ? (
                        <Typography
                            variant="body1"
                            fontWeight="bold"
                            color="text-white dark:!text-black"
                        >
                            PFP Drop
                        </Typography>
                    ) : null}
                    {price ? (
                        <Typography
                            variant="body1"
                            fontWeight="bold"
                            color="text-white dark:!text-black"
                        >
                            {price}
                        </Typography>
                    ) : null}
                    {maxClaimable > 0 ? (
                        <Typography
                            variant="body1"
                            color="text-white dark:!text-black"
                        >
                            {`${
                                maxClaimable - numClaimed
                            } / ${maxClaimable} in stock`}
                        </Typography>
                    ) : maxClaimable === 0 ? (
                        <Typography
                            variant="body1"
                            color="text-white dark:!text-black"
                        >
                            {`${
                                maxClaimable - numClaimed
                            } / ${maxClaimable} in stock`}
                        </Typography>
                    ) : null}
                </div>
            </Link>
        </Card>
    )
}
